export type SlashCommand = {
  name: string;
  description: string;
  slash: string;
  args_schema?: unknown;
};

export type ParsedInput =
  | { kind: 'slash'; command: string; args: string }
  | { kind: 'chat'; text: string };

export function parseSlash(input: string, registry: SlashCommand[]): ParsedInput {
  const m = input.match(/^\/(\w+)(?:\s+(.*))?$/);
  if (!m) return { kind: 'chat', text: input };
  const [, typedName, args = ''] = m;
  // Match against the slash field (e.g. '/today') case-insensitively, then
  // return the tool's canonical name so /command receives the right name.
  const entry = registry.find((c) => c.slash.toLowerCase() === `/${typedName!.toLowerCase()}`);
  if (!entry) return { kind: 'chat', text: input };
  return { kind: 'slash', command: entry.name, args };
}
